import { editorEndpoints } from '$/services/endpoints';
import { fetcher } from '$/services/fetcher';
import { ImageUploadSchema } from '$/services/usecases/editor/mapper/imageUpload';
import { convertToBase64 } from '$/utils/codeBase64';

export const uploadProjectImage = async (selectedFile: File | null) => {
  if (!selectedFile) return;

  const { token } = await fetcher(editorEndpoints.EDITOR_IMAGE_UPLOAD, {
    method: 'POST',
    msg: 'Failed to upload project image',
    body: { image: await convertToBase64(selectedFile) },
    parser: (data) => ImageUploadSchema.parse(data),
  });

  return token;
};
